var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.3125C14.7249 15.3125 15.3125 14.7249 15.3125 14C15.3125 13.2751 14.7249 12.6875 14 12.6875C13.2751 12.6875 12.6875 13.2751 12.6875 14C12.6875 14.7249 13.2751 15.3125 14 15.3125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.3125C14.7249 8.3125 15.3125 7.72487 15.3125 7C15.3125 6.27513 14.7249 5.6875 14 5.6875C13.2751 5.6875 12.6875 6.27513 12.6875 7C12.6875 7.72487 13.2751 8.3125 14 8.3125Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.3125C14.7249 22.3125 15.3125 21.7249 15.3125 21C15.3125 20.2751 14.7249 19.6875 14 19.6875C13.2751 19.6875 12.6875 20.2751 12.6875 21C12.6875 21.7249 13.2751 22.3125 14 22.3125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/three-dot-vertical.08f7ec4a106e23626aedec31f0dfad9b.svg";
export { ForwardRef as ReactComponent };